import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  Dispatch,
  SetStateAction,
  useContext,
  useState,
  createContext,
} from "react";
import { Button, Menu, MenuList, useTheme } from "@mui/material";
import { Row } from "./index";
import {
  SetRequirementStatusMenuItem,
  SetRequirementStatusDialog,
} from "./SetRequirementStatus";

const buttonId = "requirements-bulk-actions-button";
const menuId = "requirements-bulk-actions-menu";

type DialogState = "setRequirementStatus" | null;

const bulkActionContext = createContext<{
  selectedRows: Row[];
  dialogState: DialogState;
  setDialogState: Dispatch<SetStateAction<DialogState>>;
  onClose: () => void;
}>({
  selectedRows: [],
  dialogState: null,
  setDialogState: () => {},
  onClose: () => {},
});

export function useBulkActionContext() {
  return useContext(bulkActionContext);
}

export function BulkActionsMenu({ selectedRows }: { selectedRows: Row[] }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [dialogState, setDialogState] = useState<DialogState>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
    setDialogState(null);
  };

  const theme = useTheme();

  return (
    <bulkActionContext.Provider
      value={{ selectedRows, onClose, dialogState, setDialogState }}
    >
      <Button
        id={buttonId}
        size="medium"
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disabled={!selectedRows.length}
        variant="contained"
        onClick={handleClick}
        endIcon={<ExpandMore />}
        sx={{
          whiteSpace: "nowrap",
          backgroundColor: theme.palette.secondary.main,
        }}
      >
        Bulk Actions ({selectedRows.length})
      </Button>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        MenuListProps={{ "aria-labelledby": buttonId }}
      >
        <MenuList>
          <SetRequirementStatusMenuItem />
        </MenuList>
      </Menu>
      <SetRequirementStatusDialog />
    </bulkActionContext.Provider>
  );
}
